import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OpenMailIcon = (props: IconProps) => (
  <Icon w="16px" h="17px" viewBox="0 0 16 17" {...props}>
    <path d="M14.6599 6.83366C14.6599 6.35366 14.4133 5.93366 14.0333 5.70033L7.99992 2.16699L1.96659 5.70033C1.58659 5.93366 1.33325 6.35366 1.33325 6.83366V13.5003C1.33325 14.2337 1.93325 14.8337 2.66659 14.8337H13.3333C14.0666 14.8337 14.6666 14.2337 14.6666 13.5003L14.6599 6.83366ZM13.3266 6.83366V6.84033L7.99992 10.167L2.66659 6.83366L7.99992 3.71366L13.3266 6.83366ZM2.66659 13.5003V8.39366L7.99992 11.7403L13.3266 8.41366L13.3333 13.5003H2.66659Z" />
  </Icon>
);

export default memo(OpenMailIcon);
